export const PHONE_NUMBER    = '+91 98911 56565';
export const WHATSAPP_NUMBER = '919891156565';
export const EMAIL_ADDRESS   = 'info@smartpropertysolutions.in';
// export const RERA_NUMBER     = 'UPRERAPRJ123456';

export const CITIES = ['Delhi NCR', 'Dholera SIR', 'Ahmedabad'];

export const PROPERTY_TYPES = ['Apartment', 'Plot', 'Commercial'];

export const LISTING_TYPES = ['Sale', 'Rent', 'New Launch'];

// Demo fallback — used only when backend is offline
export const DEMO_PROPERTIES = [];

export const formatPrice = (price) => {
  if (!price) return 'Price on Request';
  const n = Number(price);
  if (n >= 10000000) return `₹${(n/10000000).toFixed(2).replace(/\.?0+$/,'')} Cr`;
  if (n >= 100000)   return `₹${(n/100000).toFixed(2).replace(/\.?0+$/,'')} L`;
  return `₹${n.toLocaleString('en-IN')}`;
};

export const formatArea = (area) => {
  if (!area) return '';
  return `${Number(area).toLocaleString('en-IN')} sq.ft.`;
};
